import plugin from './plugin';
import DateRangePicker_ from './DateRangePicker';

export const DateRangePicker = DateRangePicker_;
export default plugin;
